<div class="pt-3" *ngIf="customerNotFound">
  <h2>Customer not found.</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3" *ngIf="!customerNotFound && (serverError === null)">

  <div *ngIf="successMessage" class="alert alert-success text-center" role="alert">
    {{ successMessage }}
  </div>

  <div class="rounded-table-wrapper rounded-table-tight table-responsive">
    <table class="table table-12px">

      <thead>
      <tr>
        <th scope="col" colspan="99" class="text-primary"
            style="font-size: 16px; padding-top: 8px; padding-bottom: 8px;">
          <div class="float-right">
            <button class="btn btn-sm btn-outline-primary mr-2"
                    style="font-size: 12px; line-height: 12px;"
                    (click)="handleAddCreditOrVoucher()">
              Add
            </button>
            <button class="btn btn-sm btn-outline-primary"
                    style="font-size: 12px; line-height: 12px;"
                    [disabled]="loadingCustomer"
                    [class.disabled]="loadingCustomer"
                    (click)="openPurchaseVoucherPackModal()">
              Purchase Voucher Pack
            </button>
          </div>
          <span style="position: relative; top: 4px;">Credits &amp; Vouchers</span>
        </th>
      </tr>
      <tr>
        <th scope="col">Status</th>
        <th scope="col">Date Added</th>
        <th scope="col">Type</th>
        <th scope="col">Balance</th>
        <th scope="col">Expiry</th>
        <th scope="col">Source</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="creditsAndVouchers && (creditsAndVouchers.length > 0)">
      <tr *ngFor="let creditOrVoucher of creditsAndVouchers">

        <td [class.text-success]="creditOrVoucher.status === CreditOrVoucherStatus.active"
            [class.text-danger]="creditOrVoucher.status !== CreditOrVoucherStatus.active">
          {{ getStatusString(creditOrVoucher.status) }}
        </td>

        <td>{{ creditOrVoucher.dateAddedStr }}</td>

        <td *ngIf="creditOrVoucher.credit" style="line-height: 16px">
          Credit <br>
          <span class="text-muted">
            {{ getCreditRecurringPaymentString(creditOrVoucher.credit) }}
          </span>
        </td>
        <td *ngIf="creditOrVoucher.voucher">
          Voucher:
          <span *ngIf="creditOrVoucher.voucher.event_type_name">{{ creditOrVoucher.voucher.event_type_name }}</span>
          <span *ngIf="creditOrVoucher.voucher.event_category_name">{{ creditOrVoucher.voucher.event_category_name }}</span>
        </td>

        <td *ngIf="creditOrVoucher.credit">{{ organizationConfigService.getCurrencySymbol() }}{{ creditOrVoucher.credit.amount_remaining }}</td>
        <td *ngIf="creditOrVoucher.voucher">
          {{ creditOrVoucher.voucher.number_of_uses_remaining }} /
          {{ creditOrVoucher.voucher.number_of_uses_total }}
        </td>

        <td *ngIf="creditOrVoucher.expiryDateStr">{{ creditOrVoucher.expiryDateStr }}</td>
        <td *ngIf="!creditOrVoucher.expiryDateStr" class="text-muted">None</td>

        <td *ngIf="creditOrVoucher.credit">
          <span *ngIf="creditOrVoucher.createdById">
            Created by {{ creditOrVoucher.createdByFirstName }} {{ creditOrVoucher.createdByLastName }}
          </span>
          <span *ngIf="!creditOrVoucher.createdById" class="text-muted">Automatic</span>
        </td>
        <td *ngIf="creditOrVoucher.voucher">
          <span *ngIf="creditOrVoucher.voucher.created_by_id !== null">
            Created by {{ creditOrVoucher.voucher.created_by_first_name }} {{ creditOrVoucher.voucher.created_by_last_name}}
          </span>
          <span *ngIf="creditOrVoucher.voucher.membership_id !== null">
            Membership: {{ creditOrVoucher.voucher.membership_name }}
          </span>
          <span *ngIf="creditOrVoucher.voucher.voucher_pack_id !== null">
            Voucher Pack: {{ creditOrVoucher.voucher.voucher_pack_name }}
          </span>
          <span *ngIf="(creditOrVoucher.voucher.voucher_pack_id === null) && (creditOrVoucher.voucher.invoice_id !== null)">
            Purchased
          </span>
        </td>

        <td class="table-12px-button-cell">
          <button class="btn btn-sm btn-outline-secondary table-12px-button customer-table-button float-right disabled"
             *ngIf="creditOrVoucher.isLoading" disabled>
            Loading
          </button>
          <button class="btn btn-sm btn-outline-danger table-12px-button customer-table-button float-right"
             *ngIf="!creditOrVoucher.isLoading && !creditOrVoucher.isRemoved"
             (click)="removeCreditOrVoucher(creditOrVoucher)">
            Remove
          </button>
          <button class="btn btn-sm btn-outline-success table-12px-button customer-table-button float-right"
             *ngIf="!creditOrVoucher.isLoading && creditOrVoucher.isRemoved"
             (click)="restoreCreditOrVoucher(creditOrVoucher)">
            Restore
          </button>
        </td>

      </tr>
      </tbody>

      <tbody *ngIf="!(creditsAndVouchers && (creditsAndVouchers.length > 0))">
      <tr>
        <td colspan="99">
          {{ loadingCreditsAndVouchers ? 'Loading...' : 'No credits or vouchers'}}
        </td>
      </tr>
      </tbody>

    </table>
  </div>
</div>
